<template>
    <div style="height: inherit;">
        <div>
            <Header />
        </div>
        <div class="content__positioning distancing text input-forms-size">
            <div v-if="view == 'log-in'">
              <login-page @forgotPassword='forgotPassword'></login-page>
            </div>
            <div v-if="view == 'forgot-pass'">
              <forgot-password @confirm='confirm'></forgot-password>
            </div>
            <div v-if="view == 'confirm-page'">
              <confirm-page></confirm-page>
            </div>
        </div>
        <footer-view></footer-view>

    </div>
</template>

<script>
import Header from '@components/design/HeaderDesign'
import LoginPage from '@components/login/Loginpage.vue'
import ForgotPassword from '@components/login/ForgotPassword.vue'
import ConfirmPage from '@components/login/ConfirmPage.vue'
import FooterView from '@components/footer/FooterView.vue'
export default {
  name: 'Login',
  data: function () {
    return {
      view: 'log-in'
    }
  },
  components: {
    Header,
    LoginPage,
    ForgotPassword,
    ConfirmPage,
    FooterView
  },
  methods: {
    forgotPassword () {
      this.view = 'forgot-pass'
    },
    confirm () {
      this.view = 'confirm-page'
    }
  }
}
</script>
